import { render, staticRenderFns } from "./Content_selectbooks.vue?vue&type=template&id=6ce86ce6&scoped=true"
import script from "./Content_selectbooks.vue?vue&type=script&lang=js"
export * from "./Content_selectbooks.vue?vue&type=script&lang=js"
import style0 from "./Content_selectbooks.vue?vue&type=style&index=0&id=6ce86ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce86ce6",
  null
  
)

export default component.exports